import type { RouterConfig } from '@nuxt/schema'

const legacyRedirects = [
  ['/profile/signature-standards/advanced-update', '/profile/signature-standards/update'],
  ['/direct-sign/advanced-identification', '/direct-sign/identification'],
] as const

export default {
  routes: routes => [
    ...routes,
    ...legacyRedirects.map(([from, to]) => ({
      path: `${from}/:rest(.*)*`,
      redirect: (route: { fullPath: string }) => route.fullPath.replace(from, to),
    })),
  ],
} satisfies RouterConfig
